import React from 'react';
import PropTypes from 'prop-types';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import { Button } from 'react-bootstrap';

import { useNavigate } from 'react-router-dom';
import routes from 'app/routes';
import { useContext } from '../../Context';

export default function Actions({ row }) {
  const { dispatch, actions } = useContext();
  const navigate = useNavigate();

  const editResource = () => {
    navigate(routes.admin.resources.edit(row.id));
  };

  const deleteResource = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this resource?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.delete(dispatch, row.id);
        }
      },
    );
  };

  return (
    <div>
      <Button onClick={() => editResource()} bsClass="btn-link">
        <img src={editIcon} alt="edit" />
      </Button>
      <Button onClick={(e) => deleteResource(e)} bsClass="btn-link">
        <img src={deleteIcon} alt="delete" />
      </Button>
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
